import { render } from "./App.vue?vue&type=template&id=f2c21490"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f2c21490&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__